import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = { class: "w-full md:w-8/12" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-y-4 gap-x-6 px-4" }
const _hoisted_4 = { class: "w-full md:w-8/12" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-y-4 gap-x-6 px-4" }
const _hoisted_6 = { class: "w-full md:w-8/12" }
const _hoisted_7 = { class: "grid grid-cols-1 gap-y-4 gap-x-6 px-4" }
const _hoisted_8 = { class: "w-full md:w-8/12" }
const _hoisted_9 = { class: "grid grid-cols-1 gap-y-4 gap-x-6 px-4" }
const _hoisted_10 = { class: "w-full md:w-8/12" }
const _hoisted_11 = { class: "grid grid-cols-1 gap-y-4 gap-x-6 px-4" }
const _hoisted_12 = { class: "w-full md:w-8/12" }
const _hoisted_13 = { class: "grid grid-cols-1 gap-y-4 gap-x-6 px-4" }
const _hoisted_14 = { class: "w-full md:w-8/12" }
const _hoisted_15 = { class: "grid grid-cols-2 gap-y-4 gap-x-6 px-4" }
const _hoisted_16 = { class: "w-full md:w-8/12" }
const _hoisted_17 = { class: "grid grid-cols-2 gap-y-4 gap-x-6 px-4" }
const _hoisted_18 = { class: "w-full md:w-8/12" }
const _hoisted_19 = { class: "grid grid-cols-2 gap-y-4 gap-x-6 px-4" }
const _hoisted_20 = { class: "w-full md:w-8/12" }
const _hoisted_21 = { class: "grid grid-cols-2 gap-y-4 gap-x-6 px-4" }
const _hoisted_22 = { class: "w-full md:w-8/12" }
const _hoisted_23 = { class: "gap-y-4 gap-x-6 px-4" }
const _hoisted_24 = { class: "space-y-2 pt-2" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "text-12px font-normal text-gray-lp-500 max-w-md" }, " Klik tombol di bawah ini untuk mengaktifkan atau menonaktifkan status ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_MultipleSelectProduct = _resolveComponent("MultipleSelectProduct")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    onBack: _ctx.goBack,
    title: `Ubah ${_ctx.getTitle}`,
    "full-page": "",
    "custom-class": "px-0",
    "vertical-separator": false,
    "leave-page-confirmation": _ctx.leavePageConfirmation,
    "onUpdate:leave-page-confirmation": _cache[17] || (_cache[17] = ($event: any) => (_ctx.leavePageConfirmation = $event)),
    onLeavePage: _ctx.onLeavePage,
    loading: _ctx.isLoading,
    error: !!_ctx.errorCause,
    errorType: _ctx.errorCause,
    onTryAgain: _ctx.fetchDetail
  }, {
    "top-right": _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_lp_button, {
          "text-color": "white",
          customClass: "w-full py-2.5",
          title: "Simpan",
          onClick: _ctx.onSaveForm,
          disabled: !_ctx.isFormValid
        }, null, 8, ["onClick", "disabled"])
      ])
    ]),
    data: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_DataWrapper, {
            label: "ID Konfigurasi",
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                disabled: "",
                disableBackground: "",
                modelValue: _ctx.form.configId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.configId = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "Nama Konfigurasi",
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                disabled: "",
                disableBackground: "",
                modelValue: _ctx.form.configName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.configName = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_DataWrapper, {
            label: "Deskripsi Konfigurasi",
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                type: "textarea",
                textAreaRows: "3",
                modelValue: _ctx.form.configDescription,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.configDescription = $event)),
                maxLength: "255",
                minLength: "3"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_DataWrapper, {
            label: "Tipe Total Harga COD",
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                disabled: "",
                disableBackground: "",
                modelValue: _ctx.form.typeCodPrice,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.typeCodPrice = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_DataWrapper, {
            label: "Jenis Pengiriman",
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_MultipleSelectProduct, {
                status: "active",
                class: "my-1.5",
                placeholder: "Pilih jenis pengiriman",
                modelValue: _ctx.form.products,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.products = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_DataWrapper, {
            label: "Asuransi",
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CustomDropdown, {
                options: _ctx.insurances,
                selectedItem: _ctx.form.insurance,
                "onUpdate:selectedItem": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.insurance = $event)),
                placeholder: "Pilih Asuransi",
                class: "my-1.5",
                expandUpwards: true
              }, null, 8, ["options", "selectedItem"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_DataWrapper, {
            label: "Kota Penyedia Booking STT COD",
            optional: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_MultipleSelectSearch, {
                "modal-title": "Pilih kota ",
                "option-name": "kota",
                onFocus: _ctx.fetchCity,
                onFilter: _ctx.filterCity,
                options: _ctx.cityOptions,
                modelValue: _ctx.form.cities,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.cities = $event)),
                keyName: "name",
                keyValue: "value",
                placeholder: "Ketik atau pilih kota",
                isLoading: _ctx.isLoadingCity,
                showReset: "",
                "able-to-delete-in-modal": "",
                class: "my-1.5",
                displayValue: ""
              }, null, 8, ["onFocus", "onFilter", "options", "modelValue", "isLoading"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_14, [
        _createVNode("div", _hoisted_15, [
          _createVNode(_component_DataWrapper, {
            label: "Minimal Harga Barang",
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, _mergeProps({
                modelValue: _ctx.form.priceMinimal,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.priceMinimal = $event)),
                prefix: "IDR",
                format: _ctx.formatInputNumberAbleZero
              }, _ctx.priceMinimalValidity), null, 16, ["modelValue", "format"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "Maksimal Harga Barang",
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.form.priceMaximal,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.priceMaximal = $event)),
                prefix: "IDR",
                format: _ctx.formatInputNumberAbleZero,
                error: 
                _ctx.priceMaximalValidity.error || _ctx.priceMaximalSmallerThan.error
              ,
                errorCaption: 
                _ctx.priceMaximalValidity.error
                  ? _ctx.priceMaximalValidity.errorCaption
                  : _ctx.priceMaximalSmallerThan.errorCaption
              
              }, null, 8, ["modelValue", "format", "error", "errorCaption"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode("div", _hoisted_17, [
          _createVNode(_component_DataWrapper, {
            label: "Persentase Biaya COD",
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                format: _ctx.formatFloat,
                modelValue: _ctx.form.precentageCodFee,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.precentageCodFee = $event)),
                onChange: _ctx.validatePercentageCodFee,
                error: _ctx.error.percentageCodFee.error,
                errorCaption: _ctx.error.percentageCodFee.errorCaption,
                suffix: "%"
              }, null, 8, ["format", "modelValue", "onChange", "error", "errorCaption"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "Minimal Biaya COD",
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.form.minimalCodFee,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.minimalCodFee = $event)),
                prefix: "IDR",
                format: _ctx.formatInputNumberAbleZero,
                error: _ctx.minCodFreeLargerThan.error,
                errorCaption: _ctx.minCodFreeLargerThan.errorCaption
              }, null, 8, ["modelValue", "format", "error", "errorCaption"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _createVNode(_component_DataWrapper, {
            label: "Persentase Komisi COD POS Asal",
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                format: _ctx.formatFloat,
                modelValue: _ctx.form.commissionOriginPos,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.commissionOriginPos = $event)),
                onChange: _ctx.validateCommissionOriginPos,
                error: _ctx.error.commissionOriginPos.error,
                errorCaption: _ctx.error.commissionOriginPos.errorCaption,
                suffix: "%"
              }, null, 8, ["format", "modelValue", "onChange", "error", "errorCaption"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "Persentase Komisi COD POS Tujuan",
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                format: _ctx.formatFloat,
                modelValue: _ctx.form.commissionDestinationPos,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.commissionDestinationPos = $event)),
                onChange: _ctx.validateCommissionOriginDestination,
                error: _ctx.error.commissionOriginDestination.error,
                errorCaption: _ctx.error.commissionOriginDestination.errorCaption,
                suffix: "%"
              }, null, 8, ["format", "modelValue", "onChange", "error", "errorCaption"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_20, [
        _createVNode("div", _hoisted_21, [
          _createVNode(_component_DataWrapper, {
            label: "Minimal Komisi COD POS Asal",
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.form.minCommissionCODOriginPOS,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.minCommissionCODOriginPOS = $event)),
                prefix: "IDR",
                format: _ctx.formatInputNumberAbleZero
              }, null, 8, ["modelValue", "format"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "Minimal Komisi COD POS Tujuan",
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.form.minCommissionCODDestinationPOS,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.minCommissionCODDestinationPOS = $event)),
                prefix: "IDR",
                format: _ctx.formatInputNumberAbleZero
              }, null, 8, ["modelValue", "format"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_22, [
        _createVNode("div", _hoisted_23, [
          _createVNode(_component_DataWrapper, {
            label: "Status Konfigurasi COD",
            class: "my-6"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_component_Toggle, {
                  onChange: _ctx.onUpdateStatus,
                  modelValue: _ctx.form.status,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.status = $event)),
                  textActive: "Aktif",
                  textInactive: "Tidak Aktif"
                }, null, 8, ["onChange", "modelValue"])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBack", "title", "leave-page-confirmation", "onLeavePage", "loading", "error", "errorType", "onTryAgain"]))
}